import { z } from 'zod';
const getShiftPositionDetailsParamsSchema = z.object({
    shiftId: z.string().uuid(),
    positionId: z.string().uuid(),
});
const getShiftPositionDetailsResponseSchema = z.union([
    z.object({
        occupationGroup: z.string().optional(),
        occupations: z.string().optional(),
        ecls: z.string().optional(),
        skills: z.string().optional(),
        trainings: z.string().optional(),
        languages: z.string().optional(),
        state: z.string().optional(),
        counties: z.string().optional(),
        tribes: z.string().optional(),
        deploymentDuration: z.string().optional(),
        deploymentTravelWillingness: z.string().optional(),
        federalDeploymentWillingness: z.string().optional(),
        priorCommitments: z.string().optional(),
    }),
    z.void(),
]);
export const getShiftPositionDetailsFunctionDef = {
    name: 'getShiftPositionDetails',
    requestSchema: getShiftPositionDetailsParamsSchema,
    responseSchema: getShiftPositionDetailsResponseSchema,
};
